// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3XpD2","inputWrap":"styles_inputWrap__XGV85","input":"styles_input__2iOjc"};